import createValueModule from "../create-value-module";
// this store is used to store the current playing video reference which used to stop all other players in the page.
const { reducer, actions } = createValueModule("videoPlayer", {
    videoref: {},
});
export default reducer;
export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;
